// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#999","menuActiveText":"#fff"};